<template>
	<div class="panel panel-custom">
		<div class="panel-heading">
			<i class="fa fa-lock pull-right" style="margin-top:5px;"></i>
			<strong class="text-uppercase">AUTENTICAÇÃO</strong>
		</div>
		<div class="panel-body">
			<!-- error message -->
			<div class="alert alert-danger" style="margin-bottom:10px;" v-if="errorMessage">
				<strong>{{ errorMessage }}</strong>
			</div>

			<form @submit.prevent="login">
				<v-input
					type="tel"
					label="CPF"
					v-model="form.usuario"
					:mask="{ format: '99999999999' }"
					:error-message="validate('isNotBlank', form.usuario, 'Preenchimento obrigatório')"
				></v-input>
				<v-input
					type="password"
					label="SENHA"
					v-model="form.senha"
					maxlength="20"
					:error-message="validate('hasMinLength', form.senha, 5, 'Deve conter ao menos 5 caracteres')"
				></v-input>

				<!-- on tablets and pcs -->
				<div class="row hidden-xs">
					<div class="col-xs-6">
						<router-link to="/recuperarsenha" class="btn btn-warning btn-block">
							ESQUECI A SENHA
						</router-link>
					</div>
					<div class="col-xs-6">
						<button type="submit" class="btn btn-success btn-block">LOGIN</button>
					</div>
				</div>

				<!-- on smartphones -->
				<div class="visible-xs">
					<div class="btn-group btn-group-justified">
						<div class="btn-group">
							<router-link to="/recuperarsenha" class="btn btn-warning">
								ESQUECI A SENHA
							</router-link>
						</div>
						<div class="btn-group">
							<button type="submit" class="btn btn-success">LOGIN</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import Form from 'helpers/form';
	import rules from 'helpers/validationRules';
	import Municipe from 'models/municipe';

	export default {
		props: {
			redirectTo: {
				default: '/'
			}
		},

		data() {
			return {
				validating: false,
				errorMessage: '',

				form: new Form({
					usuario: '',
					senha: ''
				})
			};
		},

		async created() {
			if (this.redirectTo === '/') {
				try {
					let municipe = await Municipe.getCurrent();

					if (municipe) {
						this.$router.push('/agendas');
					}
				} catch(e) {}
			}
		},

		methods: {
			validate(rule, value, arg, message) {
				if (message === undefined) {
					message = arg;
				}

				if (this.validating) {
					return rules[rule](value, arg) ? '' : message;
				}
			},

			hasValidationErrors() {
				let fields = document.querySelectorAll('.has-error');

				return fields.length > 0;
			},

			login() {
				let url = `${Config.BASE_URL}/permisys`;

				this.validating = true;

				this.$nextTick(() => {
					if (this.hasValidationErrors() === false) {
						this.form.save(url)
							.then(() => {
								location.reload();
							})
							.catch(error => {
								this.errorMessage = error.responseJSON.message || error.responseJSON.errorMessage;
							})
							.done(() => {
								setTimeout(() => {
									this.errorMessage = '';
								}, 5000);
							});
					} else {
						window.scrollTo(0, 0);
					}
				});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// login.vue?2f39effa